(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ble-garan-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ble-garan-label')) {
  customElements.define('ble-garan-label', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const trigger = this.querySelector('.ble-garan-label__trigger');
      const dialog = this.querySelector('.ble-garan-label__dialog');
      const close = this.querySelector('.ble-garan-label__close');
      if (!trigger || !dialog) return;
      trigger.addEventListener('click', () => dialog.showModal(), { signal });
      close?.addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }, { signal });
    }
    disconnectedCallback() { this.abortController?.abort(); this.abortController = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["garan-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('garan-label')) {
    customElements.define(
      'garan-label',
      class GaranLabel extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.garan-label__trigger');
          this.dialog = this.querySelector('.garan-label__dialog');
          this.closeButton = this.querySelector('.garan-label__close');

          if (!this.trigger || !this.dialog) return;

          this.trigger.addEventListener('click', () => this.dialog.showModal());
          this.closeButton?.addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
